import { render, staticRenderFns } from "./SiteTermsDialog.vue?vue&type=template&id=263c8994"
import script from "./SiteTermsDialog.vue?vue&type=script&lang=ts"
export * from "./SiteTermsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports